import { useEffect, useMemo, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useQueryVariables } from './store'
import OPERATION_FIND_COUPONS_STANDARD, { OPERATION_FIND_COUPONS_H3 } from './operations-gql/queries'

const LIMIT = 10

const useSearch = ({ standard }) => {
  const [shouldFetchNextPage, setShouldFetchNextPage] = useState(true)
  const queryVariables = useQueryVariables()

  const queryParams = useMemo(() => {
    return {
      ...queryVariables,
      langue: localStorage.i18nextLng,
      offset: 0,
      limit: LIMIT
    }
  }, [queryVariables])

  const { error, loading, data, refetch, fetchMore, networkStatus } = useQuery(
    standard ? OPERATION_FIND_COUPONS_STANDARD : OPERATION_FIND_COUPONS_H3,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      variables: queryParams
    }
  )

  useEffect(() => {
    refetch(queryParams).then(() => setShouldFetchNextPage(true))
  }, [queryVariables])

  return {
    error,
    loading: (loading && networkStatus !== 3) || networkStatus === 2,
    data,
    loadingNext: networkStatus === 3,
    fetchNextPage: async () => {
      const fetchMoreResult = await fetchMore({
        variables: {
          offset: data ? data.coupons.length : 0,
          limit: LIMIT
        }
      })
      if (!fetchMoreResult.data.coupons.length || fetchMoreResult.data.coupons.length < LIMIT) {
        setShouldFetchNextPage(false)
      }
    },
    shouldFetchNextPage: !loading && data && data.coupons.length >= LIMIT && shouldFetchNextPage
  }
}

export default useSearch
